<script lang="ts">
	import { Button, Text, Input } from '@Shelly/shelly-design-system';
	import {
		control_bluetooth_device_ios,
		control_bluetooth_dw_min_angel_threshold_ios,
	} from 'src/services/native_container_requests_ios';
	import {
		control_bluetooth_device_android,
		control_bluetooth_dw_min_angel_threshold_android,
	} from 'src/services/native_container_requests_android';

	import { app, os } from 'src/stores/session/native-bridge';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';
	import { format } from 'svelte-i18n';
	import { valueOutOfRange } from 'src/helpers/utilities';
	import { BLU_STATUS } from 'src/types/requests/settings/blu_status';

	export let device;

	const min = 0;
	const max = 90;
	let minAngleThreshold: any = device?.minAngleThreshold || min;
	let initialized = false;

	const onSave = () => {
		if ($controlBleDevice.connectionState === 2) {
			$os === 'IOS'
				? control_bluetooth_dw_min_angel_threshold_ios(device.id, minAngleThreshold)
				: control_bluetooth_dw_min_angel_threshold_android(device.id, minAngleThreshold);

			bulkUpdate(device.id, { minAngleThreshold });
		} else {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};

	$: switch ($controlBleDevice.currentStatusIndex) {
		// after receiving one of the statuses below remove the initialized state
		case BLU_STATUS.UNHANDLED_STATE:
		case BLU_STATUS.BUTTON_PRESS_REQUIRED:
		case BLU_STATUS.CONNECT_TO_DEVICE:
		case BLU_STATUS.DISCONNECT_FROM_DEVICE:
			initialized = false;
			break;
		// after receiving one of the statuses below add the initialized state
		case BLU_STATUS.DEVICE_OTA_AVAILABLE:
		case BLU_STATUS.DEVICE_OTA_REQUIRED:
		case BLU_STATUS.DEVICE_PROCESSED:
		case BLU_STATUS.BEACON_ENABLED:
		case BLU_STATUS.BEACON_DISABLED:
		case BLU_STATUS.MIN_ANGLE_THRESHOLD_SET:
			initialized = true;
			break;
		default:
			break;
	}

	$: error = valueOutOfRange(minAngleThreshold, min, max)
		? $format('error_out_of_range', {
				default: `Value ${minAngleThreshold} is out of range. Please provide a value within the limits. (${min} — ${max})`,
				values: { value: minAngleThreshold, max, min, unit: '°' },
			})
		: '';
</script>

<Text class="mb-s ml-s" element="p" styleType="body-small">
	{$format('text_blu_setting_angle_threshold', {
		default: 'This setting determines the minimum rotation angle that will be sent as angle report.',
	})}
</Text>

<Input
	aria-label={$format('input_blu_setting_angle_threshold', {
		default:
			'Enter the minimum rotation angle that will be sent as angle report. Value must be between {min} — {max}!',
	})}
	icon="fas fa-angle"
	class="mb-m"
	bind:value={minAngleThreshold}
	type="number"
	step={1}
	{min}
	{max}
	info={$format('movement_limit_toast', {
		default: 'Values must be between {min} — {max}!',
		values: { min, max },
	})}
	{error}
	id="input-uvj5267"
/>

<Button disabled={!initialized || !$app || error} size="m" width="full" on:click={onSave}>
	{$format('button_save', { default: 'Save' })}
</Button>
